import { FormOutlined, InboxOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, Row, Select, SelectProps, Space, Upload, notification } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAllAcoes } from "../../../api/acoes";
import { editClientesById, getAnexosByClientesId, getClientesById } from "../../../api/clientes";
import InputNormal from "../../../components/InputNormal";
import { useLoading } from "../../../contexts/LoadingContext";
import { ClienteEnums } from '../../../enums/ClienteEnums';
import { formatTimeStampToHoras } from "../../../helpers/timestampToHoras";
import { AcaoType } from "../../../types/AcaoType";
import { FileType } from '../../../types/FileType';
import AnexosComponent from "./components/AnexosView";

const { Option } = Select;

const formItemLayout = {
    labelCol: { flex: '0 0 25px' }, // Ajuste a largura das labels conforme necessário
    wrapperCol: { flex: '1' },
};

export default function TelaCliente() {
    const [acoes, setAcoes] = useState<SelectProps['options']>([]);
    const [acoesSelected, setAcoesSelected] = useState<any>([]);
    const [clienteSelected, setClienteSelected] = useState<any>([]);
    const [loadingEditButton, setLoadingEditButton] = useState<boolean>(false);
    const [hasFinished, setHasFinished] = useState<boolean>(false);
    const { setLoading } = useLoading();
    const [form] = Form.useForm();
    const { idCliente } = useParams();
    let navigate = useNavigate();
    const [fileList, setFileList] = useState([]);
    const [listFiles, setListFiles] = useState<FileType[]>([]);
    const [initLoading, setInitLoading] = useState(true);

    const getCliente = async () => {
        setLoading(true);
        const response = await getClientesById(idCliente as string).then((res) => {
            const acoesDoCliente = res.data[0].acoes.map((acao: any) => {
                return {
                    value: acao.id,
                    label: acao.tipoAcao
                }
            });

            form.setFieldsValue({
                ...res.data[0],
                acoes: acoesDoCliente
            })
            setClienteSelected({
                ...res.data[0],
                acoes: acoesDoCliente
            });
            setLoading(false);
        });
        return response;
    };

    useEffect(() => {
        setLoading(true);
        getAllAcoes().then((res) => {
            const acoesData = res.data.map((acao: AcaoType) => {
                return {
                    value: acao.id,
                    label: acao.nome_acao
                }
            });
            setAcoes(acoesData);
            getCliente();
        });
        loadAnexos();
    }, []);

    const normFile = (e: any) => {
        if (Array.isArray(e)) {
            return e;
        }
        setFileList(e.fileList);
        return e && e.fileList;
    };

    const validateMessages = {
        required: '${label} é obrigatório!',
        types: {
            email: '${label} não é um email válido, verifique se você digitou @gmail por exemplo!',
            number: '${label} is not a valid number!',
        },
    };

    const loadAnexos = async () => {
        setInitLoading(true);
        const response = getAnexosByClientesId(idCliente as string);
        response.then((res) => {
            setListFiles(res.data.data);
            setInitLoading(false);
        });
    };


    return (
        <Row gutter={12}>
            <Col span={15}>
                <Card title="Visualizar cliente">
                    <Form
                        name="wrap"
                        onFinish={(values) => {
                            if (values && acoesSelected) {
                                setLoadingEditButton(true);
                                const formValues = { id: idCliente, acoes: values.acoes || acoesSelected, ...values }
                                const response = editClientesById(formValues);
                                response.then((response) => {
                                    if (response.status !== 200) {
                                        notification.error({
                                            message: 'Erro!',
                                            description: 'Ocorreu um erro ao editar o cliente, verifique os dados e tente novamente.',
                                            duration: 5
                                        });
                                        setLoadingEditButton(false);
                                        return;
                                    }

                                    notification.success({
                                        message: 'Sucesso!',
                                        description: 'Cliente editado com sucesso!',
                                        duration: 5
                                    });
                                    getCliente();
                                    setFileList([]);
                                    form.setFieldsValue({ files: [] });
                                    setLoadingEditButton(false);
                                    setHasFinished(true);
                                    loadAnexos();
                                    // navigate(-1);
                                });
                            }
                        }}
                        labelCol={formItemLayout.labelCol}
                        labelAlign="left"
                        layout="vertical" // Usando layout "vertical" para colocar os labels acima dos campos
                        colon={false}
                        validateMessages={validateMessages}
                        form={form}
                    >
                        <Row gutter={16}>
                            <Col span={12}>
                                <InputNormal label="Nome:" name="nome" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                            </Col>
                            <Col span={12}>
                                <InputNormal label="Endereço:" name="endereco" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={6}>
                                <InputNormal label="RG:" name="rg" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                            </Col>
                            <Col span={6}>
                                <InputNormal label="CPF:" name="cpf" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                            </Col>
                            <Col span={6}>
                                <InputNormal label="Email:" name="email" rules={[{ required: false, type: 'email' }]} />
                            </Col>
                            <Col span={6}>
                                <Form.Item
                                    name="telefone"
                                    label="Telefone:"
                                    rules={[{ required: false, message: 'Please input your phone number!' }]
                                    }
                                >
                                    <Input
                                        // addonBefore={prefixSelector}
                                        style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item
                                    name="nacionalidade"
                                    label="Nacionalidade"
                                    rules={[{ required: true, message: 'Por favor, selecione um país!' }]}
                                >
                                    <Select placeholder="Por favor, selecione um país!">
                                        <Option value="brasileira">Brasileira</Option>
                                        <Option value="outro">Outro</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    name="estado_civil"
                                    label="Estado Civil"
                                    rules={[{ required: true, message: 'Por favor, selecione um estado civil!' }]}
                                >
                                    <Select placeholder="Por favor, selecione um estado civil!">
                                        <Option value="solteiro">Solteiro(a)</Option>
                                        <Option value="casado">Casado(a)</Option>
                                        <Option value="separado">Separado(a)</Option>
                                        <Option value="divorciado">Divorciado(a)</Option>
                                        <Option value="viuvo">Viuvo(a)</Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    name="acoes"
                                    label="Ação:"
                                    rules={[{ required: true, message: 'Por favor, selecione o tipo da ação!', type: 'array' }]}
                                >
                                    <Select
                                        mode="tags"
                                        style={{ width: '100%' }}
                                        // onChange={handleChange}
                                        onSelect={(value, option) => {
                                            setAcoesSelected([...acoesSelected, option]);
                                        }}
                                        tokenSeparators={[',']}
                                        options={acoes}
                                    >
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item
                                    name="statusClienteId"
                                    label="Status:"
                                >
                                    <Select placeholder="Por favor, selecione um status!"
                                        options={[
                                            { value: ClienteEnums.ABERTO, label: 'Aberto' }, { value: ClienteEnums.ENCERRADO, label: 'Encerrado' },]}>
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={16}>
                                <Form.Item name={'anotacoes'} label="Anotações:" >
                                    <Input.TextArea />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item
                                    name="files"
                                    label="Upload de arquivos:"
                                    valuePropName="fileList"
                                    getValueFromEvent={normFile}
                                    extra="No momento o sistema aceita apenas arquivos no formato (.pdf)"
                                >
                                    <Upload.Dragger
                                        multiple={true}
                                        fileList={fileList}
                                        beforeUpload={() => false}
                                        onChange={({ fileList }: any) => setFileList(fileList)} // Garante sincronização
                                        accept=".pdf"
                                    >
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">Arraste e solte o arquivo aqui ou clique</p>
                                        <p className="ant-upload-hint">Aceita um ou mais arquivos</p>
                                    </Upload.Dragger>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row style={{ justifyContent: 'flex-end' }}>
                            <Col>
                                <Space>
                                    <Form.Item>
                                        <Button type="primary" onClick={() => {
                                            navigate('/demandas/geral');
                                        }}>
                                            VOLTAR
                                        </Button>
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type="primary" htmlType="submit" icon={<FormOutlined />} loading={loadingEditButton}>
                                            EDITAR
                                        </Button>
                                    </Form.Item>
                                </Space>
                            </Col>
                        </Row>
                    </Form>
                    <div className="created-data-form-view">{`Data de criação do cliente: ${formatTimeStampToHoras(clienteSelected.created_at)}`}</div>
                </Card>
            </Col>
            <Col span={9}>
                <Card title="Anexos:">
                    <AnexosComponent
                        idCliente={idCliente}
                        loading={hasFinished}
                        listFiles={listFiles}
                        initLoading={initLoading}
                        loadAnexos={loadAnexos} />
                </Card>
            </Col>
        </Row>
    )
}
